import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: "#673AB7",
    secondary: "#E57373",
    accent: "#9c27b0",
    error: "#F44336",
    warning: "#ffeb3b",
    info: "#2196F3",
    success: "#4CAF50"
  },
  iconfont: 'md'
})
